// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H22V2ZM6.5 8V6H17.5V8H6.5ZM12 9L16 14H13L13 18.5H11L11 14H8L12 9Z"}}]};

const BacktopRectangleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'backtop-rectangle-filled',
    ref,
    icon: element,
  },
));

BacktopRectangleFilledIcon.displayName = 'BacktopRectangleFilledIcon';

export default BacktopRectangleFilledIcon;
